// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/external_clients.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.iam.v1.GetApprovalInfoRequest
 */
export interface GetApprovalInfoRequest {
    /**
     * Encrypted DCRApprovalState token from /approve-client query param
     *
     * @generated from protobuf field: string state = 1
     */
    state: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.GetApprovalInfoResponse
 */
export interface GetApprovalInfoResponse {
    /**
     * Client name from registration metadata
     *
     * @generated from protobuf field: string client_name = 1
     */
    clientName: string;
    /**
     * Redirect URI the client will return to
     *
     * @generated from protobuf field: string redirect_uri = 2
     */
    redirectUri: string;
    /**
     * Well-known client classification - frontend maps to icon and vendor string
     *
     * @generated from protobuf field: c1.api.iam.v1.WellKnownClient well_known_client = 3
     */
    wellKnownClient: WellKnownClient;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ApproveRequest
 */
export interface ApproveRequest {
    /**
     * Encrypted DCRApprovalState token
     *
     * @generated from protobuf field: string state = 1
     */
    state: string;
    /**
     * Role IDs the user selected to grant
     *
     * @generated from protobuf field: repeated string selected_role_ids = 2
     */
    selectedRoleIds: string[];
    /**
     * Optional custom name for this connection (defaults to client_name if empty)
     *
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ApproveResponse
 */
export interface ApproveResponse {
    /**
     * Full redirect URL including authorization code and state
     *
     * @generated from protobuf field: string redirect_url = 1
     */
    redirectUrl: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceListRequest
 */
export interface ExternalClientServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceListResponse
 */
export interface ExternalClientServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.iam.v1.ExternalClientInfo list = 1
     */
    list: ExternalClientInfo[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * ExternalClientInfo provides information about an approved external client.
 * Used by both List (user's own grants) and Search (admin view of all grants).
 *
 * @generated from protobuf message c1.api.iam.v1.ExternalClientInfo
 */
export interface ExternalClientInfo {
    /**
     * OAuth2 client ID - canonical identifier for this connection (globally unique per DCR)
     *
     * @generated from protobuf field: string client_id = 1
     */
    clientId: string;
    /**
     * The user who approved this external client (always populated)
     *
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * Original client name from DCR registration
     *
     * @generated from protobuf field: string client_name = 3
     */
    clientName: string;
    /**
     * @generated from protobuf field: c1.api.iam.v1.WellKnownClient well_known_client = 4
     */
    wellKnownClient: WellKnownClient;
    /**
     * Role IDs granted to this client - frontend can fetch display names via SearchRoles
     *
     * @generated from protobuf field: repeated string role_ids = 5
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 7
     */
    lastUsedAt?: Timestamp;
    /**
     * User-provided custom name (defaults to client_name if not set)
     *
     * @generated from protobuf field: string display_name = 8
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceDeleteRequest
 */
export interface ExternalClientServiceDeleteRequest {
    /**
     * OAuth2 client ID to delete (globally unique per DCR registration)
     *
     * @generated from protobuf field: string client_id = 1
     */
    clientId: string;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceDeleteResponse
 */
export interface ExternalClientServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceUpdateRequest
 */
export interface ExternalClientServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.iam.v1.ExternalClientInfo client = 1
     */
    client?: ExternalClientInfo;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientServiceUpdateResponse
 */
export interface ExternalClientServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.iam.v1.ExternalClientInfo client = 1
     */
    client?: ExternalClientInfo;
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchRequest
 */
export interface ExternalClientSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Free-text search on client_name and user display name
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * Filter by specific user IDs
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef users = 4
     */
    users: UserRef[];
    /**
     * Filter by well-known client type (e.g., CLAUDE_CODE, CURSOR, etc.)
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.WellKnownClient well_known_clients = 5
     */
    wellKnownClients: WellKnownClient[];
}
/**
 * @generated from protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchResponse
 */
export interface ExternalClientSearchServiceSearchResponse {
    /**
     * Uses ExternalClientInfo with user_id populated for admin views
     *
     * @generated from protobuf field: repeated c1.api.iam.v1.ExternalClientInfo list = 1
     */
    list: ExternalClientInfo[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * ExternalClientGrantRef is used for websocket notifications.
 *
 * @generated from protobuf message c1.api.iam.v1.ExternalClientGrantRef
 */
export interface ExternalClientGrantRef {
    /**
     * @generated from protobuf field: string client_id = 1
     */
    clientId: string;
}
/**
 * WellKnownClient identifies recognized MCP client applications.
 * Used for UX (icons, vendor info). Values match c1.models.oauth.v1.WellKnownClient.
 *
 * @generated from protobuf enum c1.api.iam.v1.WellKnownClient
 */
export enum WellKnownClient {
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_UNKNOWN = 1;
     */
    UNKNOWN = 1,
    /**
     * Anthropic
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_AI = 2;
     */
    CLAUDE_AI = 2,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_DESKTOP = 3;
     */
    CLAUDE_DESKTOP = 3,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CLAUDE_CODE = 4;
     */
    CLAUDE_CODE = 4,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_MCP_INSPECTOR = 5;
     */
    MCP_INSPECTOR = 5,
    /**
     * OpenAI
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CHATGPT = 6;
     */
    CHATGPT = 6,
    /**
     * Microsoft
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_VSCODE = 7;
     */
    VSCODE = 7,
    /**
     * IDEs
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_CURSOR = 10;
     */
    CURSOR = 10,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_WINDSURF = 11;
     */
    WINDSURF = 11,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_ZED = 12;
     */
    ZED = 12,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_JETBRAINS = 13;
     */
    JETBRAINS = 13,
    /**
     * Other
     *
     * @generated from protobuf enum value: WELL_KNOWN_CLIENT_DOCKER_MCP_TOOLKIT = 15;
     */
    DOCKER_MCP_TOOLKIT = 15
}
// @generated message type with reflection information, may provide speed optimized methods
class GetApprovalInfoRequest$Type extends MessageType<GetApprovalInfoRequest> {
    constructor() {
        super("c1.api.iam.v1.GetApprovalInfoRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<GetApprovalInfoRequest>): GetApprovalInfoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = "";
        if (value !== undefined)
            reflectionMergePartial<GetApprovalInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetApprovalInfoRequest): GetApprovalInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string state */ 1:
                    message.state = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetApprovalInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string state = 1; */
        if (message.state !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetApprovalInfoRequest
 */
export const GetApprovalInfoRequest = new GetApprovalInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetApprovalInfoResponse$Type extends MessageType<GetApprovalInfoResponse> {
    constructor() {
        super("c1.api.iam.v1.GetApprovalInfoResponse", [
            { no: 1, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "well_known_client", kind: "enum", T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"] }
        ]);
    }
    create(value?: PartialMessage<GetApprovalInfoResponse>): GetApprovalInfoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientName = "";
        message.redirectUri = "";
        message.wellKnownClient = 0;
        if (value !== undefined)
            reflectionMergePartial<GetApprovalInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetApprovalInfoResponse): GetApprovalInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_name */ 1:
                    message.clientName = reader.string();
                    break;
                case /* string redirect_uri */ 2:
                    message.redirectUri = reader.string();
                    break;
                case /* c1.api.iam.v1.WellKnownClient well_known_client */ 3:
                    message.wellKnownClient = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetApprovalInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_name = 1; */
        if (message.clientName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientName);
        /* string redirect_uri = 2; */
        if (message.redirectUri !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.redirectUri);
        /* c1.api.iam.v1.WellKnownClient well_known_client = 3; */
        if (message.wellKnownClient !== 0)
            writer.tag(3, WireType.Varint).int32(message.wellKnownClient);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.GetApprovalInfoResponse
 */
export const GetApprovalInfoResponse = new GetApprovalInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApproveRequest$Type extends MessageType<ApproveRequest> {
    constructor() {
        super("c1.api.iam.v1.ApproveRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "8192" } } } },
            { no: 2, name: "selected_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ApproveRequest>): ApproveRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = "";
        message.selectedRoleIds = [];
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ApproveRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApproveRequest): ApproveRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string state */ 1:
                    message.state = reader.string();
                    break;
                case /* repeated string selected_role_ids */ 2:
                    message.selectedRoleIds.push(reader.string());
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApproveRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string state = 1; */
        if (message.state !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.state);
        /* repeated string selected_role_ids = 2; */
        for (let i = 0; i < message.selectedRoleIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.selectedRoleIds[i]);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ApproveRequest
 */
export const ApproveRequest = new ApproveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApproveResponse$Type extends MessageType<ApproveResponse> {
    constructor() {
        super("c1.api.iam.v1.ApproveResponse", [
            { no: 1, name: "redirect_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ApproveResponse>): ApproveResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.redirectUrl = "";
        if (value !== undefined)
            reflectionMergePartial<ApproveResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApproveResponse): ApproveResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string redirect_url */ 1:
                    message.redirectUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApproveResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string redirect_url = 1; */
        if (message.redirectUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.redirectUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ApproveResponse
 */
export const ApproveResponse = new ApproveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceListRequest$Type extends MessageType<ExternalClientServiceListRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<ExternalClientServiceListRequest>): ExternalClientServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceListRequest): ExternalClientServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceListRequest
 */
export const ExternalClientServiceListRequest = new ExternalClientServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceListResponse$Type extends MessageType<ExternalClientServiceListResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalClientInfo },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalClientServiceListResponse>): ExternalClientServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceListResponse): ExternalClientServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.iam.v1.ExternalClientInfo list */ 1:
                    message.list.push(ExternalClientInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.iam.v1.ExternalClientInfo list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ExternalClientInfo.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceListResponse
 */
export const ExternalClientServiceListResponse = new ExternalClientServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientInfo$Type extends MessageType<ExternalClientInfo> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientInfo", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "well_known_client", kind: "enum", T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"] },
            { no: 5, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "last_used_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalClientInfo>): ExternalClientInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientId = "";
        message.userId = "";
        message.clientName = "";
        message.wellKnownClient = 0;
        message.roleIds = [];
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientInfo): ExternalClientInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* string client_name */ 3:
                    message.clientName = reader.string();
                    break;
                case /* c1.api.iam.v1.WellKnownClient well_known_client */ 4:
                    message.wellKnownClient = reader.int32();
                    break;
                case /* repeated string role_ids */ 5:
                    message.roleIds.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp last_used_at */ 7:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                case /* string display_name */ 8:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_id = 1; */
        if (message.clientId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string client_name = 3; */
        if (message.clientName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientName);
        /* c1.api.iam.v1.WellKnownClient well_known_client = 4; */
        if (message.wellKnownClient !== 0)
            writer.tag(4, WireType.Varint).int32(message.wellKnownClient);
        /* repeated string role_ids = 5; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.roleIds[i]);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_used_at = 7; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 8; */
        if (message.displayName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientInfo
 */
export const ExternalClientInfo = new ExternalClientInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceDeleteRequest$Type extends MessageType<ExternalClientServiceDeleteRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceDeleteRequest", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<ExternalClientServiceDeleteRequest>): ExternalClientServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientId = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceDeleteRequest): ExternalClientServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_id = 1; */
        if (message.clientId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceDeleteRequest
 */
export const ExternalClientServiceDeleteRequest = new ExternalClientServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceDeleteResponse$Type extends MessageType<ExternalClientServiceDeleteResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ExternalClientServiceDeleteResponse>): ExternalClientServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceDeleteResponse): ExternalClientServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceDeleteResponse
 */
export const ExternalClientServiceDeleteResponse = new ExternalClientServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceUpdateRequest$Type extends MessageType<ExternalClientServiceUpdateRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceUpdateRequest", [
            { no: 1, name: "client", kind: "message", T: () => ExternalClientInfo, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<ExternalClientServiceUpdateRequest>): ExternalClientServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceUpdateRequest): ExternalClientServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.ExternalClientInfo client */ 1:
                    message.client = ExternalClientInfo.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.ExternalClientInfo client = 1; */
        if (message.client)
            ExternalClientInfo.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceUpdateRequest
 */
export const ExternalClientServiceUpdateRequest = new ExternalClientServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientServiceUpdateResponse$Type extends MessageType<ExternalClientServiceUpdateResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientServiceUpdateResponse", [
            { no: 1, name: "client", kind: "message", T: () => ExternalClientInfo }
        ]);
    }
    create(value?: PartialMessage<ExternalClientServiceUpdateResponse>): ExternalClientServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExternalClientServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientServiceUpdateResponse): ExternalClientServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.iam.v1.ExternalClientInfo client */ 1:
                    message.client = ExternalClientInfo.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.iam.v1.ExternalClientInfo client = 1; */
        if (message.client)
            ExternalClientInfo.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientServiceUpdateResponse
 */
export const ExternalClientServiceUpdateResponse = new ExternalClientServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientSearchServiceSearchRequest$Type extends MessageType<ExternalClientSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "well_known_clients", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.iam.v1.WellKnownClient", WellKnownClient, "WELL_KNOWN_CLIENT_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<ExternalClientSearchServiceSearchRequest>): ExternalClientSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.users = [];
        message.wellKnownClients = [];
        if (value !== undefined)
            reflectionMergePartial<ExternalClientSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientSearchServiceSearchRequest): ExternalClientSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.user.v1.UserRef users */ 4:
                    message.users.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.iam.v1.WellKnownClient well_known_clients */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.wellKnownClients.push(reader.int32());
                    else
                        message.wellKnownClients.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.user.v1.UserRef users = 4; */
        for (let i = 0; i < message.users.length; i++)
            UserRef.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.iam.v1.WellKnownClient well_known_clients = 5; */
        if (message.wellKnownClients.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.wellKnownClients.length; i++)
                writer.int32(message.wellKnownClients[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchRequest
 */
export const ExternalClientSearchServiceSearchRequest = new ExternalClientSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientSearchServiceSearchResponse$Type extends MessageType<ExternalClientSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalClientInfo },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalClientSearchServiceSearchResponse>): ExternalClientSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientSearchServiceSearchResponse): ExternalClientSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.iam.v1.ExternalClientInfo list */ 1:
                    message.list.push(ExternalClientInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.iam.v1.ExternalClientInfo list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ExternalClientInfo.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientSearchServiceSearchResponse
 */
export const ExternalClientSearchServiceSearchResponse = new ExternalClientSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalClientGrantRef$Type extends MessageType<ExternalClientGrantRef> {
    constructor() {
        super("c1.api.iam.v1.ExternalClientGrantRef", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalClientGrantRef>): ExternalClientGrantRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientId = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalClientGrantRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalClientGrantRef): ExternalClientGrantRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalClientGrantRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_id = 1; */
        if (message.clientId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ExternalClientGrantRef
 */
export const ExternalClientGrantRef = new ExternalClientGrantRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.ExternalClientService
 */
export const ExternalClientService = new ServiceType("c1.api.iam.v1.ExternalClientService", [
    { name: "GetApprovalInfo", options: { "authz.method": { role: "VIEWER" } }, I: GetApprovalInfoRequest, O: GetApprovalInfoResponse },
    { name: "Approve", options: { "authz.method": { role: "EDITOR" } }, I: ApproveRequest, O: ApproveResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ExternalClientServiceListRequest, O: ExternalClientServiceListResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ExternalClientServiceDeleteRequest, O: ExternalClientServiceDeleteResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ExternalClientServiceUpdateRequest, O: ExternalClientServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.iam.v1.ExternalClientSearchService
 */
export const ExternalClientSearchService = new ServiceType("c1.api.iam.v1.ExternalClientSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/iam/external_clients", summary: "NOTE: Searches external client grants for all users", group: "External Client" }] } }, I: ExternalClientSearchServiceSearchRequest, O: ExternalClientSearchServiceSearchResponse }
]);
